// @ts-strict-ignore
import React from 'react'
import Accordion from '../accordion'
import { useEntities, useEntity } from '../../../helpers/selectors'
import { RichText } from '../../../helpers/react'
import Image from '../../../imgix-img'
import { Card as CardAtom } from '../../../../atoms'
import { removeWhitespaceAndSpecialChars } from '../../../helpers/commons'

interface PlatinumAccordionProps {
  name: string
  title: string
  items: object[]
  variant: string
  sys: { id: string }
  brand: 'money' | 'uswitch'
}

const Card = ({ card, trackerData }: { card: any; trackerData: any }) => {
  const iconImage = useEntity(card.icon)
  const { sys, variant, name } = trackerData
  return (
    <CardAtom variant='modal'>
      <div className='PlatinumAccordion__desktop__card'>
        {iconImage.file && (
          <div className='PlatinumAccordion__desktop__card--icon'>
            <Image src={iconImage.file.url} alt={card.title} width={80} />
          </div>
        )}
        <div className='PlatinumAccordion__desktop__card--body'>
          <h3 className='PlatinumAccordion__desktop__card--title'>{card.title}</h3>
          <div
            className='PlatinumAccordion__desktop__card--richtext-content'
            /* eslint-disable camelcase */
            data-click-tracking={JSON.stringify({
              component_category: 'platinum-component',
              component_id: sys?.id,
              component_name: 'PlatinumAccordion',
              contentful_name: name,
              contentful_variant: variant,
              additionalProps: { text: card.title },
            })}
          >
            <RichText content={card.content} />
          </div>
        </div>
      </div>
    </CardAtom>
  )
}

const PlatinumAccordion: React.FC<PlatinumAccordionProps> = (props) => {
  const { title, items, sys, variant, name } = props
  const trackerData = { sys, variant, name }
  const cards = useEntities(items)

  return (
    <>
      <div className='PlatinumAccordion__mobile'>
        <Accordion {...props} />
      </div>
      <div className='PlatinumAccordion__desktop' id={removeWhitespaceAndSpecialChars(name)}>
        <h2 className='PlatinumAccordion__desktop__title'>{title}</h2>
        <div className='PlatinumAccordion__desktop__cards'>
          {cards.map((card: any, key: number) => (
            <Card card={card} trackerData={trackerData} key={key} />
          ))}
        </div>
      </div>
    </>
  )
}

export default PlatinumAccordion
